<template>
    <div>
        <app-tabela
            idTabela="tblProcessos"
            :itens="contrato.processosJudiciais"
            :campos="campos"
            :itensPorPagina="itensPorPagina"
            :bordered="false"
            :small="false"
        >
            <template slot="botoes">
                <div class="d-flex flex-row-reverse mb-3">
                    <btn-inserir
                        :contrato="contrato"
                        @obterProcessosAtualizados="obterProcessos()"
                    ></btn-inserir>
                </div>
            </template>
            <template slot="status" slot-scope="data">
                <app-status
                    :status="data.status == 1 ?  'SIM' : 'NÃO'"
                ></app-status>
            </template>
            <template slot="acoes" slot-scope="data">
                <btn-atualizar
                    :contrato="contrato"
                    :processo="data"
                    @obterProcessosAtualizados="obterProcessos()"
                ></btn-atualizar>
                <btn-excluir
                    :contrato="contrato"
                    :processo="data"
                    @obterProcessosAtualizados="obterProcessos()"
                ></btn-excluir>
                <btn-download-processo
                    v-if="data.documento"
                    :processo="data"
                ></btn-download-processo>
            </template>
        </app-tabela>
    </div>
</template>

<script>
import ProcessosJudiciaisServicos from './ProcessosJudiciaisServicos'
import BtnInserir from './BtnInserirProcesso'
import BtnAtualizar from './BtnAtualizarProcesso'
import BtnExcluir from './BtnExcluirProcesso'
import BtnDownloadProcesso from './BtnDownloadProcesso'

export default {
    components: {
        BtnInserir,
        BtnAtualizar,
        BtnExcluir,
        BtnDownloadProcesso,
    },
    props: {
        contrato: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            itensProcessos: [],
            campos: [
                {
                    key: 'codigo',
                    label: 'Número',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'descricao',
                    label: 'Descrição',
                    sortable: true,
                },
                {
                    key: 'documento',
                    label: 'Documento',
                    sortable: true,
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 5
        }
    },
    methods: {
        obterProcessos() {
            this.$store.dispatch('addRequest')
            ProcessosJudiciaisServicos.obterProcessos(
                this.$route.params.contratoId
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.$emit('atualizarProcessos', response.data)
                    } else {
                        this.$toast.error(
                            'Erro ao obter as manutenções',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {},

    computed: {},

    watch: {}
}
</script>
